import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ConfirmationModel} from "../../../models/confirmation.model";
import {SvgIconComponent} from "../../svg-icon/svg-icon.component";
import {NgClass, NgForOf} from "@angular/common";
import {ConfirmationButtonType} from "./confirmation-button-type.enum";
import {HasCloseEvent} from "../../../interfaces/has-close-event.interface";
import {ConfirmationButton} from "../../../models/confirmation-button.model";
import {Router} from "@angular/router";

@Component({
  selector: 'app-confirmation',
  standalone: true,
  imports: [
    SvgIconComponent,
    NgForOf,
    NgClass
  ],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent implements HasCloseEvent{
 @Input() public data: ConfirmationModel = new ConfirmationModel();
 @Output() public closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private router: Router) {}

  protected setClass(type: ConfirmationButtonType): string {
    switch (type) {
      case ConfirmationButtonType.Confirm:
        return 'confirm';
      case ConfirmationButtonType.SecondaryConfirm:
        return 'secondary-confirm';
      case ConfirmationButtonType.Cancel:
        return 'cancel';
      default:
        return '';
    }
  }

  protected buttonClick(button: ConfirmationButton): void {
    if (button.target != null) {
      this.navigate(button.target)
    }
    this.closeEvent.emit(button.type !== ConfirmationButtonType.Cancel);
  }

  private navigate(route: string): void {
    this.router.navigate([route]).then();
  }
}
